var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner-row",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SendOnlineManifestInvitationEmail"),
        width: "425px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c("span", [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("SeaExport.PleaseConfirmEmailAddress")))
            ])
          ]),
          _c("cargo-combo-box", {
            staticStyle: { width: "270px" },
            attrs: {
              "allow-create": true,
              clearable: true,
              options: _vm.contacts,
              "label-function": _vm.labelFunction,
              "value-field": "email",
              "forbid-values": [""]
            },
            on: { clear: _vm.onClear },
            model: {
              value: _vm.toEmail,
              callback: function($$v) {
                _vm.toEmail = $$v
              },
              expression: "toEmail"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.sendHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Send")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }